/* eslint-disable linebreak-style */
import { useState, type FC, useEffect } from 'react';
import { Box, Button, Card, CardHeader, CardMedia, Divider, IconButton, Skeleton, Table, TableBody, TableCell, TableRow, Tooltip, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { Airfield } from '../../models/Airfield';
import ArrowLeftIcon from '../../icons/ArrowLeft';
import { Link as RouterLink } from 'react-router-dom';
import { AirfieldService } from '../../services/AirfieldService';
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.css";
import axios from 'axios';
import { PhotoCameraBack } from '@material-ui/icons';
import verifiedShield from '../../images/verified_Shield.png';
import NoPhotographyIcon from '@mui/icons-material/NoPhotography';





interface AirfieldDetailsBoxProps {
  airfield: Airfield
}



const AirfieldDetailsBox: FC<AirfieldDetailsBoxProps> = ({ airfield }) => {
  const { t } = useTranslation();
  const [photo, setPhoto] = useState<string[]>();
  var Carousel = require('react-responsive-carousel').Carousel;
  const [isLoadaingPhoto, setIsLoadaingPhoto] = useState<boolean>(true);

  var airfieldService = new AirfieldService();

  useEffect(() => {
    const getPhoto = async () => {
      setIsLoadaingPhoto(true);
      if (!(airfield?.id == null || airfield?.id == undefined || airfield?.id == "")) {
        var tmpPhoto = await airfieldService.getAirfieldPhoto(airfield?.id || "");
        setPhoto(tmpPhoto);
      }
      setIsLoadaingPhoto(false);

    }
    getPhoto();
  }, [airfield?.id]);

  const renderImmagini = () => {
    return photo?.map((immagine, index) => (
      <div key={index}>
        <div
          style={{
            overflow: 'hidden',
            width: '100%',
            height: 'calc(75vw / 4 * 3)', // 4:3 aspect ratio
            maxHeight: '350px', // Altezza massima dell'immagine
          }}
          key={index}

        >
          <img
            src={photo[index]}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover', // Per ritagliare l'immagine mantenendo l'aspect ratio
            }}
          />
        </div>
      </div>
    ));
  };


  return (
    <>
      <Card>

        <Box sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: "center",
          m: 1,
          borderRadius: 1,
          minWidth: 220
        }}>
          <Tooltip title={t('BACK_TO_DASHBOARD') || ''} aria-label={t('BACK_TO_DASHBOARD') || ''}>
            <IconButton
              component={RouterLink}
              to={`/`}
            >
              <ArrowLeftIcon fontSize="large" />
            </IconButton>
          </Tooltip>
          {airfield.isRegistred &&
            <Box sx={{ mt: 0.5, mr: 2 }}
              component="img"
              src={verifiedShield}
              height={25}
            />
          }
        </Box>
        <Divider />

        <Table>
          <TableBody>
            <TableRow>
              <TableCell>
                <Box
                  mr={1}
                  ml={7}
                  mt={-4}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  minWidth={300}
                  maxWidth={500}>
                  {isLoadaingPhoto ? (<><Box sx={{ alignItems: 'flex-start', mt: -5 }}>
                    <Skeleton animation="wave" variant="text" height={550} width={500} /></Box></>) : (<>
                      {!(photo && photo.length > 0 && photo[0] == "") ?
                        <Carousel
                          className="crsl"

                          showThumbs={false}
                          selectedIndex={0}>
                          {renderImmagini()}
                        </Carousel>
                        : <Box sx={{ display: "flex", justifyContent: "center", alignContent: "center" }}>
                          <Typography sx={{ mt: -1, ml: 1.5, fontSize: 85 }}>
                            {airfield.icaoCode == null ? "ICAO_404" : airfield.icaoCode}</Typography>
                          <NoPhotographyIcon sx={{ mt: -1 }} />
                        </Box>}

                    </>
                  )}

                </Box>
              </TableCell>
              <TableCell>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="subtitle1"
                      sx={{ mt: -1 }}
                    >
                      {t('NAME')}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="body1"
                      sx={{ mt: -1 }}
                    >
                      {airfield.name}
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="subtitle1"
                    >
                      {t('ICAO_CODE')}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="body1"
                    >
                      {airfield.icaoCode}
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="subtitle1"
                    >
                      {t('LATITUDE_DEG')}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="body1"
                    >
                      {airfield.latitude}
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="subtitle1"
                    >
                      {t('LONGITUDE_DEG')}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="body1"
                    >
                      {airfield.longitude}
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="subtitle1"
                    >
                      {t('REGION')}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="body1"
                    >
                      {airfield.region}
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="subtitle1"
                    >
                      {t('PROVINCE')}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="body1"
                    >
                      {airfield.province}
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="subtitle1"
                    >
                      {t('MUNICIPALITY')}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="body1"
                    >
                      {airfield.municipality}
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Card>
      {airfield.isRegistred &&

        <Button
          color="primary"
          component={RouterLink}
          sx={{ mt: 1, width: '100%' }}
          to={`/externalFlightInput/tenantId=${btoa(airfield.tenantId)}`}
          variant="contained"
        >
          <Typography fontSize={20} variant="subtitle2" >{t('INSERT_PUBLIC_AIRFIELD_BUTTON')}</Typography>
        </Button>
      }
    </>
  );
};

export default AirfieldDetailsBox;
